function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function(r2) {
      return Object.getOwnPropertyDescriptor(e, r2).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), true).forEach(function(r2) {
      _defineProperty(e, r2, t[r2]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function(r2) {
      Object.defineProperty(e, r2, Object.getOwnPropertyDescriptor(t, r2));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: true, configurable: true, writable: true }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == typeof i ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != typeof t || !t)
    return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != typeof i)
      return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
import { jsx } from "panel";
import difference from "lodash/difference";
import { SwitchEl } from "common/components/switch";
import { TooltipEl } from "common/components/tooltip";
import { ToggleEl } from "common/components/toggle";
import { ToggleSize } from "common/components/toggle/types";
import { baseComparator } from "common/util";
import { OrderBy } from "common/util/array";
import { SvgIconEl } from "common/components/svg-icon";
import { trackClick } from "../table-cell-mixins";
export function template() {
  const {
    t
  } = this.getContext("i18n");
  const RowContents = () => {
    const event = this.helpers.getFilteredEvent();
    if (this.helpers.isJsonView()) {
      return /* @__PURE__ */ jsx("pre", { sel: ".expanded-row-json" }, JSON.stringify(event, null, 2));
    }
    const properties = _objectSpread({}, event.properties);
    const pinnedKeys = this.helpers.getPinnedProperties();
    if (pinnedKeys.length) {
      const missingKeys = difference(pinnedKeys, Object.keys(properties));
      missingKeys.forEach((missingKey) => {
        properties[missingKey] = "";
      });
    }
    let sortedAvailablePropertyKeys = Object.keys(properties).sort(baseComparator({
      order: OrderBy.Ascending,
      transform: (item) => item.toLowerCase()
    }));
    if (pinnedKeys.length) {
      sortedAvailablePropertyKeys = sortedAvailablePropertyKeys.sort((a, b) => {
        const aPinned = pinnedKeys.includes(a);
        const bPinned = pinnedKeys.includes(b);
        if (aPinned && !bPinned) {
          return -1;
        } else if (bPinned) {
          return 1;
        }
        return 0;
      });
    }
    const numProps = sortedAvailablePropertyKeys.length;
    const itemsPerColumn = Math.ceil(numProps / 3);
    return /* @__PURE__ */ jsx("div", { sel: ".expanded-row-grid", "data-sentry-component": "RowContents", "data-sentry-source-file": "template.tsx" }, sortedAvailablePropertyKeys.map((key, index) => {
      const col = Math.floor(index / itemsPerColumn) + 1;
      const isLastItemInCol = index === numProps - 1 || (index + 1) % itemsPerColumn === 0;
      const value = properties[key].formattedValue;
      const href = properties[key].href;
      const raw = properties[key].raw;
      return /* @__PURE__ */ jsx("div", { sel: ".expanded-row-grid-item", class: {
        ["expanded-row-grid-item-col-".concat(col)]: true,
        "expanded-row-last-item-in-col": isLastItemInCol
      } }, this.attr("allow-pinning") && /* @__PURE__ */ jsx("div", { sel: ".expanded-row-pin", class: {
        "expanded-row-pinned": this.helpers.isPinned(key)
      }, on: {
        click: () => {
          this.helpers.onPinClick(key);
        }
      } }, /* @__PURE__ */ jsx(SvgIconEl, { attrs: {
        icon: "pin"
      } })), /* @__PURE__ */ jsx("div", { sel: ".expanded-row-label", class: {
        "expanded-row-truncate": (key === null || key === void 0 ? void 0 : key.length) > 20
      }, attrs: {
        title: key
      } }, "".concat(key, ":")), /* @__PURE__ */ jsx("div", { sel: ".expanded-row-item-text" }, href ? /* @__PURE__ */ jsx("a", { attrs: {
        href,
        target: "_blank",
        rel: "noopener noreferrer"
      }, on: {
        click: (ev) => trackClick(ev, href, key)
      } }, value) : value, /* @__PURE__ */ jsx(TooltipEl, null, typeof raw === "string" ? raw : value)));
    }));
  };
  return /* @__PURE__ */ jsx("div", { sel: ".expanded-row", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, /* @__PURE__ */ jsx("div", { sel: ".expanded-row-header" }, !this.attr("hide-property-key-filter") && /* @__PURE__ */ jsx(ToggleEl, { attrs: {
    selected: this.attr("property-key-filter"),
    size: ToggleSize.Medium,
    theme: this.attr("toggletheme"),
    options: this.helpers.getPropertyKeyFilter()
  }, on: {
    select: this.helpers.onSelectPropertyKeyFilter
  } }), !this.attr("hide-view-format-switch") && /* @__PURE__ */ jsx("div", { sel: ".expanded-row-switch" }, /* @__PURE__ */ jsx(SwitchEl, { attrs: {
    on: this.helpers.isJsonView()
  }, on: {
    change: this.helpers.onChangeViewFormat
  } }), /* @__PURE__ */ jsx("div", { sel: ".expanded-row-switch-label" }, t("events.json-mode")))), /* @__PURE__ */ jsx(RowContents, { "data-sentry-element": "RowContents", "data-sentry-source-file": "template.tsx" }));
}
